<template>
    <div class="flex h-screen overflow-hidden bg-muted">
        <!-- Desktop sidebar -->
        <div class="hidden lg:block shrink-0">
            <Sidebar />
        </div>

        <!-- Mobile drawer -->
        <USlideover v-model:open="sidebarOpen" side="left" :ui="{ content: 'w-62 max-w-[80vw]' }">
            <template #content>
                <Sidebar />
            </template>
        </USlideover>

        <!-- Main column -->
        <div class="flex flex-1 flex-col overflow-hidden">
            <Topbar />
            <main class="flex-1 overflow-y-auto p-4 sm:p-6">
                <div class="mx-auto max-w-360">
                    <router-view />
                </div>
            </main>
        </div>

        <!-- Global reservation wizard -->
        <ReservationWizard />

        <!-- Global loader overlay -->
        <div
            v-if="appStore.isLoaderActive()"
            class="fixed inset-0 z-50 flex items-center justify-center bg-inverted/10 backdrop-blur-[1px]"
        >
            <UIcon name="i-lucide-loader-circle" class="size-8 animate-spin text-primary" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import Sidebar from '@/layouts/components/Sidebar.vue'
    import Topbar  from '@/layouts/components/Topbar.vue'
    import ReservationWizard from '@/views/reservation/components/ReservationWizard.vue'

    import { sidebarOpen } from '@/layouts/layout'
    import { useAppStore } from '@/stores/app'

    const appStore = useAppStore()
</script>
